import type { PublicLiveSession } from '@youga/youga-interfaces';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value != null;
}

function isPublicLiveSession(value: unknown): value is PublicLiveSession {
  if (!isRecord(value) || !isRecord(value.title)) return false;

  return (
    typeof value.id === 'string' &&
    typeof value.title.pl === 'string' &&
    typeof value.startsAt === 'string' &&
    typeof value.joinWindowActive === 'boolean' &&
    (value.imageUrl == null || typeof value.imageUrl === 'string')
  );
}

export function normalizeLiveSessions(value: unknown): PublicLiveSession[] {
  if (!isRecord(value) || !Array.isArray(value.rows)) return [];
  return value.rows.filter(isPublicLiveSession).map((session) => {
    const capacity = Math.min(session.capacity || 20, 20);
    const participantCount = Math.max(0, session.participantCount || 0);
    return {
      ...session,
      isFree: session.isFree === true,
      capacity,
      participantCount,
      isFull: session.isFull ?? participantCount >= capacity,
    };
  });
}

export function isLiveFeatureEnabled(value: unknown): boolean {
  return isRecord(value) && value.enabled === true;
}

export function formatLiveSessionDate(
  value: string,
  locale: string,
  timeZone?: string,
): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  try {
    return new Intl.DateTimeFormat(locale, {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      ...(timeZone ? { timeZone } : {}),
    }).format(date);
  } catch (_error) {
    return date.toLocaleString();
  }
}
